// Client-side subdomain helpers for signup + settings. These mirror the backend
// rules (normalizeAndValidateSubdomain) to give instant feedback; the server
// remains the source of truth (uniqueness + final validation).

// Kept in sync with reservedSubdomains in the backend branding handler.
export const RESERVED_SUBDOMAINS = new Set([
  "www", "api", "app", "admin", "mail", "smtp", "imap", "pop", "cdn", "static",
  "assets", "media", "img", "images", "institution", "institutions", "prepxai",
  "dashboard", "portal", "console", "login", "signup", "auth", "account",
  "status", "support", "help", "docs", "blog", "ftp", "ns", "ns1", "ns2",
  "test", "staging", "stage", "dev", "demo", "internal", "root", "billing",
  "pay", "payments", "webhook", "webhooks",
]);

const SUBDOMAIN_RE = /^[a-z0-9]([a-z0-9-]{1,30}[a-z0-9])$/;

// sanitizeSubdomainInput is a gentle, keystroke-friendly transform: lowercase and
// drop characters that can never be valid, while still allowing a trailing hyphen
// mid-typing. It does NOT trim leading/trailing hyphens (that would fight the
// user); validateSubdomain does the strict check on submit.
export function sanitizeSubdomainInput(raw) {
  return (raw || "").toLowerCase().replace(/[^a-z0-9-]/g, "").slice(0, 32);
}

// slugifySubdomain derives a valid provisional slug from free text (e.g. an
// institution name) for the "suggest" affordance.
export function slugifySubdomain(raw) {
  return (raw || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 32)
    .replace(/-+$/g, "");
}

// validateSubdomain returns "" when valid, else a user-facing error message.
export function validateSubdomain(raw) {
  const s = (raw || "").toLowerCase().trim();
  if (!s) return "Please choose a subdomain.";
  if (s.length < 3 || s.length > 32) return "Use between 3 and 32 characters.";
  if (s.includes("--")) return "No consecutive hyphens.";
  if (!SUBDOMAIN_RE.test(s))
    return "Use lowercase letters, numbers and single hyphens (no leading or trailing hyphen).";
  if (RESERVED_SUBDOMAINS.has(s)) return "That subdomain is reserved. Please choose another.";
  return "";
}
